module.exports = __webpack_public_path__ + "static/media/Physics.35774c6c.gif";